var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useLocation, useSearchParams } from "react-router-dom";
import _ from "lodash";
import { accountDetails } from "@salesdi";
export function detectMimeType(b64) {
    var signatures = {
        JVBERi0: "application/pdf",
        R0lGODdh: "image/gif",
        R0lGODlh: "image/gif",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpg",
    };
    for (var s in signatures) {
        if (b64.indexOf(s) === 0) {
            return signatures[s];
        }
    }
}
export function useQuery() {
    return new URLSearchParams(useLocation().search);
}
export function getQueryParameterName(paramName) {
    var query = useQuery();
    return query.get(paramName);
}
export function removeQueryParmaterName(all) {
    var query = useQuery();
    var searchParams = useSearchParams();
}
export function changesQueryParameter(cb, queryList) {
    var queryObj = {};
    queryList.forEach(function (query) {
        queryObj = __assign(__assign({}, queryObj), query);
    });
    return cb(queryObj);
}
export function getImageString(b64) {
    if (b64)
        return "data:" + detectMimeType(b64) + ";base64," + b64;
    else
        return "";
}
export function base64toExcel(respData, fileName) {
    var decodedPdfContent = window.atob(respData);
    var byteArray = new Uint8Array(decodedPdfContent.length);
    for (var i = 0; i < decodedPdfContent.length; i++) {
        byteArray[i] = decodedPdfContent.charCodeAt(i);
    }
    var blob = new Blob([byteArray.buffer], { type: "application/vnd.ms-excel" });
    var _pdfurl = URL.createObjectURL(blob);
    var link = document.createElement("a");
    document.body.appendChild(link);
    link.href = _pdfurl;
    link.download = fileName;
    var evt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
    });
    link.dispatchEvent(evt);
    window.URL.revokeObjectURL(_pdfurl);
    link.remove();
}
export function base64toZip(respData, fileName) {
    var decodedPdfContentzip = window.atob(respData);
    var byteArrayzip = new Uint8Array(decodedPdfContentzip.length);
    for (var i = 0; i < decodedPdfContentzip.length; i++) {
        byteArrayzip[i] = decodedPdfContentzip.charCodeAt(i);
    }
    var blobzip = new Blob([byteArrayzip.buffer], { type: "application/zip" });
    var _pdfurlzip = URL.createObjectURL(blobzip);
    var linkzip = document.createElement("a");
    document.body.appendChild(linkzip);
    linkzip.href = _pdfurlzip;
    linkzip.download = fileName;
    var evtzip = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
    });
    linkzip.dispatchEvent(evtzip);
    window.URL.revokeObjectURL(_pdfurlzip);
    linkzip.remove();
}
export function base64toPDF(respData, fileName) {
    var decodedPdfContents = window.atob(respData);
    var byteArrays = new Uint8Array(decodedPdfContents.length);
    for (var i = 0; i < decodedPdfContents.length; i++) {
        byteArrays[i] = decodedPdfContents.charCodeAt(i);
    }
    var blobs = new Blob([byteArrays.buffer], { type: "application/pdf" });
    var _pdfurls = URL.createObjectURL(blobs);
    var links = document.createElement("a");
    document.body.appendChild(links);
    links.href = _pdfurls;
    links.download = fileName;
    var evts = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
    });
    links.dispatchEvent(evts);
    window.URL.revokeObjectURL(_pdfurls);
    links.remove();
}
export var getImageBase64String = function (file) {
    console.log("file", file);
    return new Promise(function (resolve, reject) {
        var fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = function () {
            resolve(fileReader.result);
        };
        fileReader.onerror = function (error) {
            reject(error);
        };
    });
};
export var downloadBase64Image = function (b64String, fileName) {
    if (b64String) {
        var downloadLink = document.createElement("a");
        downloadLink.href = b64String;
        downloadLink.download = fileName;
        downloadLink.click();
    }
};
export var getImageFileExtension = function (base64String) {
    switch (base64String) {
        case "image/gif":
            return ".gif";
        case "image/png":
            return ".png";
        case "image/jpg":
            return ".jpg";
    }
};
export var copyTextToClipboard = function (textToCopy) {
    if (!!textToCopy) {
        return navigator.clipboard.writeText(textToCopy);
    }
    return Promise.reject("Error copying data to clipboard");
};
export var debounce = _.debounce(function (func) {
    func();
}, 500);
export var capitalizeFirstLetter = function (str) {
    if (!str)
        return "";
    var splittedString = str.toLowerCase().trim().split(" ");
    var changeCase = function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    };
    return splittedString.length > 1
        ? splittedString.map(function (item) { return changeCase(item); }).join(" ")
        : changeCase(str);
};
export var checkIfMFIsAccessible = function () { return __awaiter(void 0, void 0, void 0, function () {
    var userData;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, accountDetails.getLoggedInUserAccountDetailsFromTokenInSalesJourney()];
            case 1:
                userData = _b.sent();
                try {
                    return [2 /*return*/, ((process.env.NODE_ENV !== "cug" &&
                            process.env.NODE_ENV !== "production") ||
                            ((_a = userData === null || userData === void 0 ? void 0 : userData.IsMfAccess) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true")];
                }
                catch (e) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/];
        }
    });
}); };
export var checkIfOtcIsAccessible = function () { return __awaiter(void 0, void 0, void 0, function () {
    var userData;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, accountDetails.getLoggedInUserAccountDetailsFromTokenInSalesJourney()];
            case 1:
                userData = _b.sent();
                try {
                    return [2 /*return*/, ((_a = userData === null || userData === void 0 ? void 0 : userData.Is_otcaccess) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true"];
                }
                catch (e) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/];
        }
    });
}); };
export var checkIfARNIsAccessible = function () { return __awaiter(void 0, void 0, void 0, function () {
    var userData;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, accountDetails.getLoggedInUserAccountDetailsFromTokenInSalesJourney()];
            case 1:
                userData = _b.sent();
                try {
                    return [2 /*return*/, ((_a = userData === null || userData === void 0 ? void 0 : userData.Is_arnaccess) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true"];
                }
                catch (e) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/];
        }
    });
}); };
